const createFileFromImageUrl = async (imageUrl: string, filename?: string) => {
  filename ??= imageUrl.split('/').pop()

  if (!filename) {
    return
  }

  const response = await fetch(imageUrl)

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  const blob = await response.blob()
  const mimeType = blob.type
  const file = new File([blob], filename, { type: mimeType })

  return file
}

export { createFileFromImageUrl }
